<template>
	<section class="section">
		<h1 class="title">Tags</h1>
		<ul>
			<li v-for="tag in tags"
					v-bind:key="tag.key">
				<a v-bind:href="'/#/tags/' + tag.key">
					{{ tag.key }}
				</a> ({{ tag.value }})
			</li>
		</ul>
	</section>
</template>

<script>
	import {db} from '@/variables.js'

	export default {
		data: function () {
			return {
				tags: []
			}
		},
		created: function() {
			var vm = this

			db.query( 'recipes/tags', {
				group: true,
			}).then( function( res ) {
				console.log( res )
				vm.tags = res.rows
			}).catch( function( err ) {
				throw err
			})
		}
	}
</script>
